import VueCookies from 'vue-cookies'
import $const from '@/utils/const'
import $http from '@/plugins/axios'
import store from '@/store/store'
import { actionTypes } from '@/store/actionTypes'

const currentProjectIdKey = 'currentProject'

const AuthService = {
    getToken () {
        return VueCookies.get($const.TOKEN_KEY)
    },
    setToken (token) {
        return VueCookies.set($const.TOKEN_KEY, token)
    },
    removeToken () {
        return $http.post('/logout/', { refresh_token: VueCookies.get($const.REFRESH_TOKEN_KEY), token:  VueCookies.get($const.TOKEN_KEY)})
    },
    getRefreshToken () {
        return VueCookies.get($const.REFRESH_TOKEN_KEY)
    },
    setRefreshToken (token) {
        return VueCookies.set($const.REFRESH_TOKEN_KEY, token)
    },
    removeRefreshToken () {
        return VueCookies.remove($const.REFRESH_TOKEN_KEY)
    },
    getLoginMethod () {
        return VueCookies.get($const.LOGIN_METHOD_KEY)
    },
    setLoginMethod (method) {
        return VueCookies.set($const.LOGIN_METHOD_KEY, method, '1d', null, process.env.VUE_APP_COOKIE_DOMAIN)
    },
    getCurrentProjectId (email) {
        if (email && VueCookies.get(`${email}_${currentProjectIdKey}`)) {
            return VueCookies.get(`${email}_${currentProjectIdKey}`)
        }
        return ''
    },
    setCurrentProjectId (email, projectId) {
        return VueCookies.set(`${email}_${currentProjectIdKey}`, projectId)
    },
    refreshToken () {
        $http.post('/token/refresh/', { refresh: VueCookies.get($const.REFRESH_TOKEN_KEY) }).then(
            result => {
                let token = result.data.access
                this.setToken(token)
                store.commit(actionTypes.user.TOKEN, token)
            }
        )
    },
    setTokenTimer (refreshToken, expire) {
        this.setRefreshToken(refreshToken)
        // TODO settimer to check expire token
    },
}

export default AuthService
